import getAdobeAnalyticsData from '@tcp/core/src/adobeAnalytics/adobeData.mapper';
import { getAPIConfig } from '@tcp/core/src/utils';
import { trackError } from '@tcp/core/src/utils/errorReporter.util';


const setAdobeAnalyticsData = (eventType, data) => {
  return getAdobeAnalyticsData(eventType, data);
};

export function getPLPPageName(breadCrumbs){
  let pageName = `${breadCrumbs?.[1]?.displayName}`;
  if (breadCrumbs?.[2]?.displayName) {
    pageName += `:${breadCrumbs?.[2]?.displayName}`;
  }
  if (breadCrumbs?.[3]?.displayName) {
    pageName += `:${breadCrumbs?.[3]?.displayName}`;
  }
  return pageName;
}
function pushEventToAdobeAnalytics(eventType, data) {
  const apiConfigObj = getAPIConfig();
  const { ADOBE_CONTAINER_ID } = apiConfigObj || false;
  if (ADOBE_CONTAINER_ID) {
    try {
      const analyticData = setAdobeAnalyticsData(eventType, data);
      window.adobeDataLayer = window.adobeDataLayer || [];
      window.adobeDataLayer.push(analyticData);
      if (eventType === 'page_view') {
        window.adobeDataLayer.push({ event: 'pageview' });
      }
    } catch (err) {
      trackError({
        error: err,
        errorTags: ['Adobe-Analytics'],
      });
    }
  }
}
export default pushEventToAdobeAnalytics;
